import React, { useEffect, useState } from 'react';
import {
    FolderButton,
    FolderButtonMobile,
    FolderPreviewContainer,
    FolderTitle,
    FolderTitleContainer,
} from './folderImovel-styled';
import useImoveis from '../../api/imoveis';
import Loading from '../Loading/Loading';

const FolderImovel = ({ idAnuncio }) => {
    const { downloadFolder, previewFolder } = useImoveis();
    const [submmiting, setSubmmiting] = useState(false);
    const [isFolderWithError, setIsFolderWithError] = useState(false);

    useEffect(() => {
        previewFolder(idAnuncio)
            .then(() => {
                setIsFolderWithError(false);
            })
            .catch(() => {
                setIsFolderWithError(true);
            });
    }, [idAnuncio, previewFolder]);

    const openPdf = () => {
        setSubmmiting(true);

        downloadFolder(idAnuncio)
            .then((resp) => {
                const blob = new Blob([resp], { type: 'application/pdf' });

                const link = document.createElement('a');
                link.href = URL.createObjectURL(blob);
                link.download = 'folder.pdf';
                link.click();
            })
            .finally(() => {
                setSubmmiting(false);
            });
    };

    return (
        <>
            {!isFolderWithError && (
                <>
                    <FolderTitleContainer>
                        <FolderTitle>Folder do imóvel</FolderTitle>

                        <FolderButton
                            onClick={() => {
                                openPdf();
                            }}
                        >
                            <label>Download do folder em pdf</label>
                        </FolderButton>
                        <FolderButtonMobile
                            onClick={() => {
                                openPdf();
                            }}
                            appearance={'primaryOutline'}
                            label={'Download folder do anúncio em PDF'}
                        />
                    </FolderTitleContainer>
                    <FolderPreviewContainer>
                        <iframe
                            src={`${process.env.API_URL}/vitrine-imoveis/folder/preview/${idAnuncio}`}
                            width="100%"
                            height="700px"
                            scrolling="no"
                            style={{
                                border: 'none',
                            }}
                        />
                    </FolderPreviewContainer>

                    {submmiting && <Loading />}
                </>
            )}
        </>
    );
};

export default FolderImovel;
